import { render } from "./TheChuyenKhoaY.vue?vue&type=template&id=4b8a42d2"
import script from "./TheChuyenKhoaY.vue?vue&type=script&lang=js"
export * from "./TheChuyenKhoaY.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__